import axios from "axios";
import END_POINTS from "./api";

export const fetchHome = async () => {
	const response = await axios.get(END_POINTS.Home);
	return response.data.data;
};
